import React, { Component } from 'react';
import { graphql, QueryRenderer } from 'react-relay';
import { withStyles } from '@material-ui/styles';
import { Grid, TextField } from '@material-ui/core';
import LensIcon from '@material-ui/icons/Lens';
import { MIGHTYMEALS_LOGO, } from '../../constants';
import environment from '../../environment';
import useStyles from './styles';
import MMLeaderboardResult from './MMLeaderboardResult';
import moment from 'moment';

const mightyMealsLeaderboardQuery = graphql`
    query MightyMealsLeaderboardWrapperQuery(
        $event_id: Int!
        $segment_id: Int
        $page_number: Int
        $rec_per_page: Int
        $searchInput: String
    ) {
        ...MMLeaderboardResult_getLeaderboardPositions
            @arguments(event_id: $event_id, segment_id: $segment_id, page_number: $page_number, rec_per_page: $rec_per_page, searchInput: $searchInput)
    }
`;

class MightyMealsLeaderboard extends Component {
    constructor(props){
        super(props);
        this.state = {
            guest_name: '',
            searchInput: '',
            page_number: 1,
            rec_per_page: 12,
            max_page: 1,
            event: this.props.event,
            current_segment: 0,
            event_settings:
                this.props.event.event_settings &&
                this.props.event.event_settings[0]
        }

        this.setMaxPage = this.setMaxPage.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.changeSegment = this.changeSegment.bind(this);
        this.changePage = this.changePage.bind(this);
    }

    componentDidMount(){
        const game5 = this.props.event.game5;
        const today = moment();

        if(game5 && game5.quarters){
            let open_chapter;
            let temp;
            game5.quarters.forEach(quarter => {
                if(!open_chapter){
                    let open = moment(quarter.quarter_start_date).isSameOrBefore(today) && moment(quarter.quarter_end_date).isAfter(today);
                    if(open) open_chapter = quarter.quarter_number - 1;
                }
                if(moment(quarter.quarter_start_date).isSameOrBefore(today)) temp = quarter.quarter_number - 1;
            });

            if(open_chapter) this.setState({ event_settings: this.props.event.event_settings[open_chapter], current_segment: open_chapter });
            else if(temp) this.setState({ event_settings: this.props.event.event_settings[temp], current_segment: temp });
        }
    }

    setMaxPage(n){
        this.setState({ max_page: n });
    }

    handleChange(e){
        this.setState({ searchInput: e.target.value });
    }

    changeSegment(n){
        const current = this.state.current_segment;
        const max = this.props.event.event_settings.length;
        let new_segment = current + n;

        if(new_segment >= 0 && new_segment < max){
            this.setState({
                current_segment: new_segment,
                event_settings: this.props.event.event_settings[new_segment],
            });
        }
    }

    changePage(new_page){
        if(new_page > 0 && new_page <= this.state.max_page){
            this.setState({
                page_number: new_page,
            });
        }
    }

    render(){
        const { classes } = this.props;
        const { event_settings, searchInput, page_number, rec_per_page, max_page } = this.state;
        const variables = {
            event_id: parseInt(this.props.event._id),
            segment_id: parseInt(event_settings._id),
            page_number: parseInt(page_number),
            rec_per_page: parseInt(rec_per_page),
            searchInput: searchInput,
        };

        return (
            <Grid container>
                <Grid item xs={12} style={{textAlign: 'center'}}>
                    <img src={MIGHTYMEALS_LOGO} className={classes.topLogo} />
                </Grid>
                <Grid item xs={12} style={{textAlign: 'center'}}>
                    <p className={classes.topTitle}>LEADERBOARD</p>
                    <p className={classes.chapterSlider}>
                        <span className={classes.sliderArrow} onClick={() => this.changeSegment(-1)}>
                            {'<'}
                        </span>
                        &nbsp;&nbsp;&nbsp;&nbsp;{event_settings.name}&nbsp;&nbsp;&nbsp;&nbsp;
                        <span className={classes.sliderArrow} onClick={() => this.changeSegment(1)}>
                            {'>'}
                        </span>
                    </p>
                </Grid>
                <Grid item xs={12} style={{marginTop: '1em'}}>
                    <QueryRenderer
                        environment={environment}
                        query={mightyMealsLeaderboardQuery}
                        variables={variables}
                        render={({error, props}) => {
                            if(error){
                                return <div>No records found</div>
                            } else if(props){
                                return (
                                    <MMLeaderboardResult
                                        getLeaderboardPositions={props}
                                        fetch_option={'getLeaderboardPositions'}
                                        setMaxPage={this.setMaxPage}
                                        filter={variables}
                                        event_id={this.props.event._id}
                                        segment_id={event_settings._id}
                                    />
                                )
                            }
                        }}
                    />
                </Grid>
                <Grid container>
                    <Grid item xs={6} className={classes.bottomGrid}>
                        <input
                            className={classes.nameSearch}
                            placeholder='Search for someone...'
                            value={searchInput}
                            onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item xs={6} className={classes.bottomGrid}>
                        <div className={classes.pageControl}>
                            <span
                                className={page_number <= 1 ? classes.inactiveButton : classes.activeButton}
                                onClick={() => this.changePage(page_number - 1)}
                            >
                                {'<'}
                            </span>
                        {
                            Array(max_page).fill('*').map((page, i) => {
                                if(i + 1 == page_number) return <LensIcon className={classes.currentPage} key={`page-${i}`} />
                                else return <LensIcon className={classes.otherPage} key={`page-${i}`} onClick={() => this.changePage(i + 1)} />
                            })
                        }
                            <span
                                className={page_number == max_page ? classes.inactiveButton : classes.activeButton}
                                onClick={() => this.changePage(page_number + 1)}
                            >
                                {'>'}
                            </span>
                        </div>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}

export default withStyles(useStyles)(MightyMealsLeaderboard);